import {useFeatureFlagEnabled} from "posthog-js/react";

export const useHeaderFlag = () => {
  const dashboardHeaderFlag = useFeatureFlagEnabled('merchant-dashboard-header')
  return dashboardHeaderFlag
}
  

